import type { IconProps } from '../types/IconProps.ts';
export const PlaySquare: IconProps = {
    name: 'PlaySquare',
    children: [
        `<path d="M9 15.12V8.88c0-.29.3-.47.55-.34l5.25 2.78c.25.13.27.5.03.65l-5.25 3.47a.37.37 0 0 1-.58-.32" />`,
        `<path d="M3 20V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1" />`,
    ]
};